
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGetgetGoodsClass, apiGetMainlyPromoteGoods, apiGettGoodsList } from '../../api';
import AppBar from '../../components/appBar';
import Page from '../../components/page';
import TabBarChange from '@/components/tabBarChange';
export class GoodsTagIcon {
  /// 热卖
  static hot = 'hot';

  /// 秒杀
  static secondsKill = 'seconds_kill';

  /// 火爆
  static fieryFire = 'fiery_fire';

  /// 推荐
  static push = 'push';
  static getTagIcon(tag: string): string {
    const icons = {
      [GoodsTagIcon.hot]: '/pic/icon_tag_sale.png',
      [GoodsTagIcon.secondsKill]: '/pic/icon_tag_second_kill.png',
      [GoodsTagIcon.fieryFire]: '/pic/icon_tag_hot.png',
      [GoodsTagIcon.push]: '/pic/icon_tag_push.png',
    };
    return icons[tag] ?? '';
  }
}
export default function HomePageDetail() {
  const [tabLabelList, setTabLabelList] = useState<any[]>([]);
  const [tabValue, setTabValue] = useState('');
  const [shoppingCentr_data, setShoppingCentr_data] = useState<any[]>([]);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    getShopTypes(); //获取商城-分类
  }, []);
  async function getShopTypes() {
    try {
      let res = await apiGetgetGoodsClass();
      if (res.status === 200) {
        const data = {
          id: 'tuijian',
          parentId: 0,
          sortIcon: null,
          sortName: '推荐商品',
        };
        if (res?.data?.data) {
          setTabLabelList([data, ...res?.data?.data]);
        } else {
          setTabLabelList([data]);
        }
      }
    } catch (e: any) { }
  }
  async function getShopData(id: string | number) {
    try {
      if (id === 'tuijian') {
        const res = await apiGetMainlyPromoteGoods();
        if (res.status === 200) {
          setShoppingCentr_data(res.data?.data || []);
        }
      } else {
        const res = await apiGettGoodsList(id);
        if (res.status === 200) {
          setShoppingCentr_data(res.data?.data || []);
        }
      }
    } catch (e: any) { }
  }
  return (
    <Page
      className="bg-color-gray vw-100 vh-100 home-detail overflow-hidden bg-gray d-flex-c"
      appBar={<AppBar title="商城" className="bg-gray" />}
      contentClassName="flex-1 h-1 overflow-y"
    >
      <div className='bw-100'>
        <TabBarChange
          options={tabLabelList}
          value={tabValue}
          onChange={(v) => {
            setTabValue(v);
            getShopData(v);
            if (scrollRef.current) {
              scrollRef?.current?.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }
          }}
        />
      </div>
      <div className="shoppingCentre-info-page " ref={scrollRef} style={{ paddingTop: rpx(10) }}>
        <div className="shoppingCentre-data pt-10" >
          {shoppingCentr_data.map((item, index) => {
            return (
              <div
                key={index}
                className="shoppingCentre-data-item mb-8 bg-white border-radius-10"
                onClick={() => (window.location.href = `https://wap.100861.net/goods?goodsId=${item.id}&form=wsl`)}
              >
                <div className="shoppingCentre-data-item-t">
                  <img src={item?.goodsListImg} alt="" />
                </div>
                <div className="shoppingCentre-data-item-b">
                  <div className="shoppingCentre-data-item-title pl-5 mt-5">
                    {!!item.goodsTagIcon && (
                      <img
                        className="h-16 mr-5"
                        style={{ verticalAlign: 'middle' }}
                        src={GoodsTagIcon.getTagIcon(item.goodsTagIcon)}
                        alt=""
                      />
                    )}
                    {item.goodsTitle}
                  </div>
                  <div className="shoppingCentre-data-item-people mt-5 pr-5 pl-5 text-color-9 font-size-12">
                    已有{item?.virtualSales || 0}人下单
                  </div>

                  <div className="tags-box mt-5">
                    <div className="tags-box-l font-size-12">
                      {item?.goodsTags?.split(',')?.map((item: any) => {
                        return (
                          <span
                            key={item}
                            className="mr-5 mb-10 tags pv-1 ph-3 border-radius-4 font-size-12 text-color-red bg-color-red-t3"
                          >
                            {item}
                          </span>
                        );
                      })}
                    </div>

                    <div
                      className="shoppingCentre-data-item-share "
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/homepage-detail`, {
                          state: {
                            imgUrl: item.goodsDetailImg ?? '',
                            title: item.goodsTitle ?? '',
                            inviteUserId: '',
                            goodsId: item.id,
                          },
                        });
                      }}
                    >
                      <img src="/pic/icon_export.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Page>
  );
}
function rpx(t: number) {
  return (t / 375) * window.innerWidth;
}
